import React, { useEffect, useState } from 'react';
import { Box, Container } from '@material-ui/core';
import { useSnackbar } from 'notistack';

import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Page from '../../../components/Layout/Page';
import Header from './Header';
import Results from './Results';
import { SUPER_ADMIN } from '../../../utils/const/user_types';
import machineRequest from '../../../requests/api/machines';
import clientRequest from '../../../requests/api/client';
import useStyles from './styles';
import handleApiResponse from '../../../utils/handleApiResponse';

function MachineListView() {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const historyPreviousPath = history.location.state && history.location.state.prevPath === '/maquina/editar';
  const reducerFilters = useSelector((s) => s.filter.filter);
  const account = useSelector((s) => s.account);
  const [machines, setMachines] = useState([]);
  const [page, setPage] = useState(historyPreviousPath ? reducerFilters.page : 0);
  const [limit, setLimit] = useState(historyPreviousPath ? reducerFilters.limit : 10);
  const [searchValue, setSearchValue] = useState(historyPreviousPath ? reducerFilters.searchValue : '');
  const [selectedClient, setSelectedClient] = useState(historyPreviousPath ? {
    id: account.user.role === SUPER_ADMIN ? reducerFilters.selectedClient.id
      : account.user.clientId,
    name: account.user.role === SUPER_ADMIN ? reducerFilters.selectedClient.name
      : null,
  } : {
    id: account.user.role === SUPER_ADMIN ? null : account.user.clientId,
    name: null,
  });
  const [clients, setClients] = useState([]);
  const [count, setCount] = useState(null);

  // TODO - get storeID at the beginning

  const storeIdStart = null;

  useEffect(() => {
    const getMachines = async () => {
      try {
        const response = await machineRequest.getMachinesPerPage(
          page,
          limit,
          searchValue,
          selectedClient.id,
          storeIdStart,
        );
        setMachines(response.machines);
        setCount(response.totalMachines);
      } catch (err) {
        handleApiResponse(enqueueSnackbar, err, false);
      }
    };
    const getClients = async () => {
      try {
        const response = await clientRequest.getClientsPerPage(page, limit, '', selectedClient.id);
        // given that I get clients only if I am superAdmin,
        // check if there is no client selected before setting a default clientId
        // with the response's first client
        if (response.clients.length !== 0 && selectedClient.id === null) {
          setSelectedClient({
            id: response.clients[0].id,
            name: response.clients[0].name,
          });
        }
        setClients(response.clients);
      } catch (err) {
        handleApiResponse(enqueueSnackbar, err, false);
      }
    };
    if (account.user.role === SUPER_ADMIN) getClients();
    if (selectedClient.id) getMachines();
  }, [limit, page, searchValue, selectedClient]);

  return (
    <Page
      className={classes.root}
      title="Máquinas"
    >
      <Container maxWidth={false}>
        <Header />
        {machines && (
          <Box mt={3}>
            <Results
              machines={machines}
              page={page}
              count={count || 0}
              setPage={setPage}
              limit={limit}
              setLimit={setLimit}
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              selectedClient={selectedClient}
              setSelectedClient={setSelectedClient}
              clients={clients}
              role={account.user.role}
              history={history}
            />
          </Box>
        )}
      </Container>
    </Page>
  );
}

export default MachineListView;
